<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-15 15:02 -->
<!-- Description:  -->
<template>
  <div>
    <a class="list-group-item d-flex justify-content-between align-items-center"
      @click="handleClick($event)">
      <span>{{ okey }}</span>
      <span>{{ label }}</span>
    </a>
    <template v-if="opened">
      <div class="ml-4">
        <template v-if="typeofData == 'object'">
          <SettingListItem v-for="(it, ke) in item" :key="ke" :okey="`${okey}.${ke}`" :item="it"
            @wantChange="$emit('wantChange', $event)"
          ></SettingListItem>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
// script content
export default {
  name: "SettingListItem",
  components: {
    //
  },

  // directives

  props: {
    okey: {
      default: String,
    },
    item: {
      default: () => ({})
    }
  },

  data: () => ({
    opened: false,
    typeofData: null,
    label: null,
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.typeofData = typeof this.item;
    this.label = this.getLabel();
    // console.log(typeof this.item);
  },

  methods: {
    getLabel() {
      if (this.item === null)
        return this.item;
      else if(typeof this.item == 'object')
        return "[data]";
      else if (this.isPrimitive())
        return this.item;
      else
        return "";
    },
    isPrimitive() {
      return ['boolean', 'number', 'string'].includes(typeof this.item);
    },
    isContainer() {
      if(this.item === null) return false;
      return ['array', 'object'].includes(typeof this.item);
    },
    handleClick() {
      if(this.isContainer())
        this.opened=!this.opened;
      else {
        // show dialog to modify
        this.$emit('wantChange', [this.okey, this.item]);
      }
    }
    //
  }
};
</script>
<style scoped></style>
